export const sleep = ms => new Promise(r => setTimeout(r, ms));
export const randArray = array => array[Math.floor(Math.random() * array.length)];

// Shuffle an array in place. Optionally restrict the shuffling to elements within options?. bounds
export const shuffle = (array, options) =>
{
	let start = Math.max(0, Math.min(array.length-1, options?.bounds?.[0])) || 0;
	let end = Math.max(0, Math.min(array.length-1, options?.bounds?.[1])) || (array.length-1);
	if (end < start) [start, end] = [end, start];

	for (let i=end; i>=start; i--)
	{
		const j = Math.floor(Math.random() * (i-start+1)) + start;
		[array[i], array[j]] = [array[j], array[i]];
	}
	return array;
};

/**
 * Generates a random integer between the specified minimum and maximum values (inclusive).
 * @param {number} min - The minimum value for the range.
 * @param {number} max - The maximum value for the range.
 * @returns {number} A random integer within the specified range.
 */
export const randBetween = (min, max) => Math.round(Math.random() * (max - min) + min);

/**
 * Capitalizes the first character of a given string.
 * @param {String} string - The input string.
 * @returns {String} The string with the first character capitalized.
 */
export const upperFirstChar = string => (string?.charAt(0)?.toUpperCase() + string?.slice(1));

/**
 * Converts the first character of a given string to lowercase.
 * @param {String} string - The input string.
 * @returns {String} The string with the first character converted to lowercase.
 */
export const lowerFirstChar = string => (string?.charAt(0)?.toLowerCase() + string?.slice(1));

export const isStr = string => (typeof string === 'string' || string instanceof String);
/**
 * Converts HTML to plain text, with a space between block elements (`<p>a</p><p>b</p>` → "a b", not "ab")
 * DOMParser builds an inert document, so scripts don't run and images don't load (Safe for untrusted HTML)
 * @param {String} html - The HTML to strip
 * @returns {String} The text content, with whitespace collapsed and trimmed
 */
export const stripHtml = html => new DOMParser()
	.parseFromString(String(html||'').replace(/<\/(p|div|h[1-6]|li|blockquote|pre|tr)>|<br\s*\/?>/gi, '$& '), 'text/html')
	.body.textContent.replace(/\s+/g, ' ').trim();

export const truncate = (string,length,terminator) => string?.length>length ? `${string.slice(0,length)}${terminator||'...'}` : string;

export const numToEnglish = num => ['zero','one','two','three','four','five','six','seven','eight','nine','ten'][num];

export const formatCount = words =>
{
	if(typeof words!=='number') return;
	const format =
		words < 10000
			? (Math.floor((10*words/1000))/10) + 'K'
		: words >= 10000 && words < 1000000
			? Math.floor(words/1000) + 'K'
		: words >= 1000000 && words < 10000000
			? (Math.floor((10*words/1000000))/10) + 'M'
			: Math.floor(words/1000000) + 'M';
	return format;
}

// Sets an interval, invoking the callback immediately, up to maxTimes times
export const startInterval = (callback, timeout, maxTimes) =>
{
	let i = 1;
	callback();
	const interval = setInterval(() =>
	{
		callback();
		if(++i >= maxTimes) clearInterval(interval);
	}, timeout);

	return interval;
}

export const parseIfJson = (json, fallback) =>
{
	try
	{
		if(!json) throw new Error("No JSON to parse");
		return JSON.parse(json);
	}
	catch
	{
		return fallback;
	}
}

export const ifNotEmpty = array => array?.length>0 ? array : undefined;
export const last = array => array[array.length-1];

export const sum = arr => arr?.reduce((acc, cur) => acc + cur, 0);
export const avg = arr => sum(arr)/arr.length;

export const getFirstMonth = months => months?.length>0 ? months.reduce((min, obj) => (obj.year < min.year || (obj.year === min.year && obj.month_num < min.month_num)) ? obj : min) : {};
export const getLastMonth = months => months.reduce((max, obj) => (obj.year > max.year || (obj.year === max.year && obj.month_num > max.month_num)) ? obj : max);
export const findMonth = (data,month) => data?.find(e=>e.month===month);

export const collate = (...arrays) =>
{
	const maxLength = Math.max(...arrays.map(arr => arr.length));
	const result = [];

	for (let i=0; i<maxLength; i++)
	{
		for (const arr of arrays)
		{
			if (i<arr.length) result.push(arr[i]);
		}
	}

	return result;
}

export const normalizeLink = text => /^[a-z]+:\/\//i.test(text) ? text : `https://${text}`;


export const deepReplace = (value, search, replace) =>
{
	if (typeof value === 'string') return value.replace(search, replace);
	if (Array.isArray(value)) return value.map(v => deepReplace(v, search, replace));
	if (value && typeof value === 'object')
	{
		return Object.fromEntries(
			Object.entries(value).map(([k, v]) => [ k, deepReplace(v, search, replace) ])
		);
	}
	return value;
}

export const setOneState = (setStates, key, value, updater) => setStates(states => states.map(e => e[key]===value ? (typeof updater==='function'?updater(e):updater) : e));

export const quillToUrl = quill => `${quill?.title?.toLowerCase()?.replace(/['’,.]/g,'')?.replace(/[^a-z0-9]+/g,' ')?.slice(0,100)?.trim()||''} ${quill?.draft_id}`.trim().replaceAll(' ','-');
export const userToUrl = user => `${user?.name?.toLowerCase()?.replace(/['’,.]/g,'')?.replace(/[^a-z0-9]+/g,' ')?.slice(0,100)?.trim()||''} ${user?.user_id}`.trim().replaceAll(' ','-');
